import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'

export default function GlobalSearchInput({ value, onChange }) {
  return (
    <IconField iconPosition="left">
      <InputIcon className="pi pi-search"> </InputIcon>
      <InputText
        value={value}
        onChange={onChange}
        placeholder="Pesquisar"
        style={{ height: '40px', fontSize: '14px' }}
      />
    </IconField>
  )
}
